<template>
    <div>
        <div class="Aheader">
            <div v-if="bodyW > 900">
                <div>
                    <img :src='"https://iboran.com/"+headerImg' class='logo' @click='toPath("/#/index")'/>
                    <div class='h_r'>
                        <div v-for='(item,index) in headerList' :key='index' class='h_r_i' :style="{position: 'relative'}">
                            <div @click='item.url ? toPath(item.url) : ""'>{{item.title}}</div>
                            <template v-if='item.children != "" && index < 4 && index != 2 && index != 3'>
                                <div class='h_r_i_2'>
                                    <div>
                                        <div v-for='(item2,index2) in item.children' :key='index2' class='h_r_i_2_2 bbbb'>
                                            <template v-if='index2 < 2'>
                                                <div>{{item2.title}}</div>
                                                <div v-for='(item3,index3) in item2.children' :key='index3' class='h_r_i_2_3' @click='item3.url ? toPath(item3.url) : ""'>
                                                    {{item3.title}}
                                                    <span class='hot' v-if='hotList.includes(item3.title)'>HOT</span>
                                                </div>
                                            </template>
                                            <template v-if='index2 > 1'>
                                                <div>{{item2.title}}</div>
                                                <div style='display: flex;'>
                                                    <div :style="{'margin-right': index2 == 3 ? '36%' : '1%'}">
                                                        <div v-for='(item3,index3) in item2.children' :key='index3' class='h_r_i_2_3 aaa' @click='item3.url ? toPath(item3.url) : ""'>
                                                            <template v-if='index3 < (index2 == 2 ? 8 : 5)'>
                                                                {{item3.title}}
                                                                <span class='hot' v-if='hotList.includes(item3.title)'>HOT</span>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div v-for='(item3,index3) in item2.children' :key='index3' class='h_r_i_2_3 aaa' @click='item3.url ? toPath(item3.url) : ""'>
                                                            <template v-if='index3 > (index2 == 2 ? 8 : 5)'>
                                                                {{item3.title}}
                                                                <span class='hot' v-if='hotList.includes(item3.title)'>HOT</span>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if='index == 2'>
                                <div class='h_r_i_11'>
                                    <div>
                                        <div class='i_11_left'>
                                            <div v-for='(item2,index2) in item.children' :key='index2' class='h_r_i_2_22' @mouseover='nowIndex2 = index2'>
                                                <div>{{item2.title}}</div>
                                            </div>
                                        </div>
                                        <div class='i_11_right'>
                                            <div v-for='(item2,index2) in item.children[nowIndex2].children' :key='index2' class='h_r_i_2_22'>
                                                <div @click='item2.url ? toPath(item2.url) : ""'><span>{{item2.title}}</span><br><span>{{item2.text}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if='index == 3'>
                                <div class='h_r_i_23'>
                                    <div style="display: flex;flex-wrap: wrap;">
                                        <div v-for='(item2,index2) in menuList' :key='index2' class='h_r_i_2_22 menuSty'>
                                            <div @click='toPath("/#/al?type="+(item2.scode))'>{{item2.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if='index == 4'>
                                <div class='ys'>
                                    <div>
                                        <!-- <div v-for='(item2,index2) in item.children' :key='index2' class='h_r_i_2_22'>
                                            <div @click='item2.children[0].url ? toPath(item2.children[0].url) : ""'>{{item2.title}}</div>
                                        </div> -->
                                        <div class='content' @click='toPath("/#/dt?index=1")'>
                                            <div class='news'>企业动态</div>
                                            <div class='ccc'>
                                                <div v-for='(item,index) in textList' :key='index'>
                                                    <img :src='"https://iboran.com/"+item.ico' />
                                                    <div>
                                                        <div>{{item.update_time}}</div>
                                                        <p>{{item.title}}</p>
                                                        <div>{{item.subtitle}}</div>                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class='line'></div>
                                        <div class='content2' @click='toPath("/#/dt?index=2")'>
                                            <div class='news'>产品资讯</div>
                                            <div class='ccc'>
                                                <div v-for='(item,index) in textList2' :key='index'>
                                                    <img :src='"https://iboran.com/"+item.ico' />
                                                    <div>
                                                        <div>{{item.update_time}}</div>
                                                        <p>{{item.title}}</p>
                                                        <div>{{item.subtitle}}</div>                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if='index == 5'>
                                <div class='h_r_i_22'>
                                    <div>
                                        <div v-for='(item2,index2) in item.children' :key='index2' class='h_r_i_2_22'>
                                            <div @click='item2.children[0].url ? toPath(item2.children[0].url) : ""'>{{item2.title}}</div>
                                            <div class="sub">
                                                <ul class="ul">
                                                    <!--                                                <li><a href="/gsjs/index_12.aspx#about13">公司简介</a></li>-->
                                                    <li><a href="/#/we?index=1&id=1" @click="goTo()">公司简介</a></li>
                                                    <!--                                                <li><a href="/#/we?index=1">企业文化</a></li>-->
                                                    <li><a href="/#/we?index=1&id=2">发展历程</a></li>
                                                    <li><a href="/#/we?index=1&id=3">荣誉资质</a></li>
                                                    <li><a href="/#/we?index=1&id=4">联系我们</a></li>
                                                    <!--                                                <li><a href="/#/we?index=1">招募渠道</a></li>-->
                                                    <!--                                                <li><a href="/#/we?index=1">联系方式</a></li>-->
                                                    <!--                                                <li><a href="/#/we?index=1">在线留言</a></li>-->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class='but' @click='visible = true'>预约演示</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="bodyW < 900" class=" n-nav">
            <div class="n-nav-head">
                <img :src='"https://iboran.com/"+headerImg' class='logo' @click='toPath("/#/index")'/>
                <img @click="(navConf.popShow = !navConf.popShow,navConf.leftCur = false)" class="set-img" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAMAAACgaw2xAAAAIVBMVEVMaXG3t7e3t7e3t7e3t7e3t7e3t7e3t7e/v7+0tLS4uLjGlnWXAAAACnRSTlMAgEAy7NWsoAgYJnes4gAAADZJREFUeNrF0bEBADAIAkEimqj7D5wFsPba7wC3pQfXwcEjEavKpEK0FHNImsDEpnH28ajx2g/3jAYb8gMHwAAAAABJRU5ErkJggg==">
            </div>
            <div :class="{'n-nav-pop':1, 'n-nav-popShow': navConf.popShow}">
                <aside>
                    <ul>
                        <li v-for="item in headerList" @click="openNav(item,1)" :class="{'n-nav-cur': navConf.leftCur === item }" :key="item.url"><span @click='item.url ? toPath(item.url) : ""'>{{item.title}}</span></li>
                    </ul>
                    <img src="@/assets/102.png" @click="navConf.leftCur = navConf.popShow = false" />
                </aside>
                <article :class="{'n-nav-pop-right':1,'n-nav-pop-rightShow':navConf.leftCur }">
                    <h3  v-if="navConf.leftCur">{{ navConf.leftCur.title }}<i>></i></h3>
                    <ul class="n-nav-list n-nav-listOpen" v-if="navConf.leftCur && navConf.leftCur.children">
                        <li v-for="item,idx in navConf.leftCur.children"  :key="item.url + '' + idx">
                            <div @click="openNav(item) " ><span @click='item.url ? toPath(item.url) : ""'>{{item.title || item}}</span>
                                <img v-if="item.children && item.children.length" :style="{'transform': `rotateZ(${ item.open ? '0' : '180' }deg)`}" src="@/assets/103.png" /></div>
                            <ul :class="{'n-nav-list':1,'n-nav-listOpen': item.open}"  v-if="item.children && item.children.length">
                                <li v-for="c,cIdx in item.children"  :key="c.url + '' + cIdx">
                                   <div @click="openNav(c) " ><span @click='c.url ? toPath(c.url) : ""'>{{c.title || c}}</span>
                                       <img v-if="c.children && c.children.length" :style="{'transform': `rotateZ(${ c.open ? '0' : '180' }deg)`}" src="@/assets/103.png" /></div>
                                    <ul :class="{'n-nav-list':1,'n-nav-listOpen': c.open}"  v-if="c.children && c.children.length">
                                        <li v-for="g,gIdx in c.children"  :key="g.url + '' + gIdx"><div  @click="openNav(g) ">
                                            <span @click='g.url ? toPath(g.url) : ""'>{{g.title}}</span></div></li>
                                    </ul>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </article>

            </div>

        </div>

        <Loding :visible.sync='visible'></Loding>
    </div>
</template>

<script>
import axios from 'axios'
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'GET' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
export default {
    name: 'header',
    data() {
        window.vm = this;
        return {
            navConf:{
                leftCur:null,
                popShow:false,
            },
            sortCodeData: [],
            code: 0,
            visible: false,
            nowIndex: -1,
            nowIndex2: 0,
            bodyW: '',
            textList: [],
            textList2: [],
            menuList: [],
            headerImg: '',
            hotList: ['用友U9 cloud','用友NC cloud','用友Yon BIP','用友YonSuite','用友费控报销系统','A8协同管理系统','合同管理系统','协同运营系统','数字项目','全面数字化电子发票'],
            headerList: [
                {title: '首页', children: [], url: '/#/index'},
                {title: '产品中心', children: [
                    {title: '用友软件', children: [
                            {title: '用友U8 cloud', url: '/#/u8'},
                            {title: '用友U9 cloud', url: '/#/u9'},
                            {title: '用友NC cloud', url: '/#/nc'},
                            {title: '用友Yon BIP', url: '/#/bip'},
                            {title: '用友YonSuite', url: '/#/ys'},
                            {title: '用友制造业ERP', url: '/#/erp'},
                            {title: '用友CRM', url: '/#/crm'},
                            {title: '用友PLM', url: '/#/plm'},
                            {title: '用友yonbulider', url: '../../../static/home/Quanqiusiku/yonbulider.html'},
                            {title: '用友银企直联', url: '../../../static/home/Quanqiusiku/yql.html'},
                            {title: '用友费控报销系统', url: '/#/money'},
                            {title: '用友发票管理系统', url: '../../../static/home/Quanqiusiku/bill.html'},
                        ]},
                    {title: '协同软件', children: [
                            {title: 'A6协同管理系统', url: '/#/a6'},
                            {title: 'A8协同管理系统', url: '../../../static/home/Tiyan/index.html'},
                            {title: '协同办公系统', url: '../../../static/home/Zhuanq/business_scene.html'},
                            {title: '项目管理系统', url: '../../../static/home/Zhuanq/xiangmu2020.html'},
                            {title: '合同管理系统', url: '../../../static/home/Zhuanq/hetong2020.html'},
                            // {title: '费控管理系统', url: '../../../static/home/Zhuanq/feikong.html'},
                            {title: '流程管理系统', url: '../../../static/home/Zhuanq/bpm2020.html'},
                            {title: '协同运营系统', url: '../../../static/home/Sem/shuzihua.html'},
                            {title: '采购管理系统', url: '../../../static/home/Zhuanq/caigou2020.html'},
                            {title: '人事管理系统', url: '../../../static/home/Zhuanq/xinshili.html'},
                            {title: '智能费控报销系统', url: '../../../static/home/Zhuanq/feikongguanli2022.html'},
                        ]},
                    {title: '成长型企业YonSuite', children: [
                            {title: '数智财务', url: '/#/szcw'},
                            {title: '数字人力', url: '/#/y_szrl'},
                            {title: '智慧采购', url: '/#/y_zhcg'},
                            {title: '数字项目', url: '/#/y_szxm'},
                            {title: '智慧协同', url: '/#/y_zhxt'},
                            {title: '敏捷供应链', url: '/#/mjgyl'},
                            {title: '企业费用管控', url: '/#/qyfy'},
                            {title: '全面数字化电子发票', url: '/#/qmsz'},
                            {title: '合规税务', url: '/#/y_hgsw'},
                            {title: '数智财资', url: '/#/y_szcz'},
                            {title: '智能制造', url: '/#/y_znzz'},
                            {title: '数字营销', url: '/#/y_szyx'},
                            {title: '数智资产', url: '/#/y_szzc'},
                        ]},
                    {title: '领域云', children: [
                            {title: '财务云', url: '/#/cwy'},
                            {title: '人力云', url: '/#/rly'},
                            {title: '协同云', url: '/#/xty'},
                            {title: '营销云', url: '/#/yxy'},
                            {title: '采购云', url: '/#/cgy'},
                            {title: '制造云', url: '/#/zzy'},
                            {title: '资产云', url: '/#/zcy'},
                            {title: '财资云', url: '../../../static/home/Quanqiusiku/czy.html'},
                            {title: '建筑云', url: '/#/jzy'},
                            {title: '税务云', url: '/#/swy'},
                            {title: '供应链云', url: '/#/gyl'},
                        ]}
                ]},
            {title: '数智化场景', children: [
                    {title: '成长型企业云服务', children: [
                            {title: '智能财务', text: '提供精细化财务管控全场景', url: '/#/zncw'},
                            {title: '数字人力', text: '提供数字化人力服务全场景', url: '/#/szrl'},
                            {title: '智慧采购', text: '提供一站式采购服务全场景', url: '/#/zhcg'},
                            {title: '数智资产', text: '实时掌握资产运营状况和效益', url: '/#/szzc'},
                            {title: '敏捷供应链', text: '提供端到端智慧供应链全场景', url: '/#/mjgy'},
                            // {title: '数字营销', text: '提供数字营销服务全场景', url: '/#/'},
                            {title: '数字项目', text: '提供全过程的项目管理全场景', url: '/#/szxm'},
                            {title: '智慧协同', text: '提供统一门户应用全场景', url: '/#/zhxt'},
                            {title: '合规税务', text: '提供合规化的税务服务全场景', url: '/#/hgsw'},
                            {title: '智能制造', text: '提供敏捷制造服务全场景', url: '/#/znzz'},
                            {title: '数智财资', text: '多维度财资管理和风险管控', url: '/#/szcz'},
                            {title: '数智平台', text: '数智商业的应用级基础设施', url: '/#/szpt'},
                            {title: '专业行业服务', text: '驱动专业服务企业高效增长', url: '/#/zyfwhy'},
                            {title: '医药流通', text: '数据可追溯、GPS合格的一体化平台', url: '/#/yylt'},
                            {title: '零售行业', text: '快速建立全渠道营销能力', url: '/#/lshy'},
                            {title: '客户关系管理（CRM）', text: '精准获客 高效转化', url: '/#/c_crm'},
                            {title: '项目管理全场景', text: '提供集中统一的项目过程管控服务体验', url: '/#/xmgl'},
                            {title: '敏捷制造全场景', text: '构建智能生产升级的底层能力', url: '../../../static/home/Zhuanq/mjzz.html'},
                            {title: '一站式采购服务', text: '为成长型企业量身定做的采购服务平台', url: '../../../static/home/Zhuanq/yzscg.html'},
                        ]},
                    {title: '商业创新平台用友BIP', children: [
                            {title: '智能财务', text: '事项会计 只能财务', url: '/#/c_zncw'},
                            {title: '数字人力（DHR）', text: '赋能人员 激活组织', url: '/#/c_szrl'},
                            {title: '数字营销', text: '构建企业全链路数字营销能力', url: '/#/szyx'},
                            {title: '智慧采购', text: '构建采购商业协作网络', url: '/#/c_zhcg'},
                            {title: '智能制造', text: '助理制造业高质量发展', url: '/#/c_znzz'},
                            {title: '企业金融', text: '一点接入千家银行', url: '/#/qyjr'},
                            {title: '敏捷供应链', text: '敏捷供应 高效协同', url: '/#/mjgyl'},
                            {title: '协同办公', text: '一个友空间畅享企业数智化云服务', url: '/#/xtbg'},
                            {title: '数智平台', text: '数智平台', url: '/#/szpt2'},
                            {title: '全球司库', text: '数智司库，战略增值', url: '../../../static/home/Quanqiusiku/qqsk.html'},
                            {title: '财务共享', text: '共享引领 企业创变', url: '../../../static/home/Zhuanq/cwgx.html'},
                            {title: '合并报表', text: '数智引擎，报告加速', url: '../../../static/home/Zhuanq/bbhb.html'},
                        ]},

                    {title: '制造业云ERP', children: [
                            {title: '数智制造', text: '企业数智制造创新平台', url: '/#/szzz'},
                            {title: '专精特新', text: '助力“专精特新”企业重塑智能战斗力', url: '/#/zjtx'},
                            {title: '精细成本核算', text: '全面支持多成本核算体系', url: '/#/jxcb'},
                            {title: '设计制造一体化', text: '研发设计生产协同一体化', url: '/#/sjzz'},
                            {title: '项目制造', text: '项目制造全面闭环管理', url: '/#/xmzz'},
                            {title: '网络化协同', text: '从业务协同到同产业链协同', url: '/#/wlhxt'},
                            {title: '个性化定制', text: '从用户定制到柔性制造', url: '/#/gxhdz'},
                            {title: '制造服务化', text: '制造服务化转型更轻松', url: '/#/zzfw'},
                            {title: '阿米巴责任考核', text: '构建多层级阿米巴核算体系', url: '/#/amb'},
                            {title: '经营管理全球化', text: '构建全球统一协作平台', url: '/#/jygl'},
                            {title: '智能工厂', text: '从排产到入库的全流程数智化', url: '/#/zngc'},
                        ]}
                ]},
                {title: '案例中心',
                    children: [
                        {title: '制造业', text: '企业数智制造创新平台', url: '/#/al?type=101'},
                        {title: '现代服务业', text: '助力“专精特新”企业重塑智能战斗力', url: '/#/al?type=102'},
                        {title: '机械行业', text: '全面支持多成本核算体系', url: '/#/al?type=103'},
                        {title: '电子', text: '研发设计生产协同一体化', url: '/#/al?type=104'},
                        {title: '化工', text: '项目制造全面闭环管理', url: '/#/al?type=105'},
                        {title: '汽车及零部件', text: '从业务协同到同产业链协同', url: '/#/al?type=106'},
                        {title: '食品', text: '从用户定制到柔性制造', url: '/#/al?type=107'},
                        {title: '医疗及器械', text: '制造服务化转型更轻松', url: '/#/al?type=108'},
                        {title: '服装', text: '构建多层级阿米巴核算体系', url: '/#/al?type=109'},
                        {title: '零售', text: '构建全球统一协作平台', url: '/#/al?type=1010'},
                        {title: '生物科技', text: '从排产到入库的全流程数智化', url: '/#/al?type=1011'},
                    ]},
                {title: '新闻中心', children: [
                        {title: '企业动态', children: [
                                {title: '企业动态', url: '/#/dt?index=1'},
                            ], url: ''},
                        {title: '产品资讯', children: [
                                {title: '产品资讯', url: '/#/dt?index=2'},
                            ], url: ''}
                    ]},

                        {
                            title: '关于我们',
                            children: [
                                {title: '关于我们', children: [
                                    {
                                        title: '关于我们',
                                        url: '/#/we?index=1',
                                        children:[
                                            {url: '/#/we?index=1&id=1', title: '公司简介'},
                                            {url: '/#/we?index=1&id=2', title: '发展历程'},
                                            {url: '/#/we?index=1&id=3', title: '荣誉资质'},
                                            {url: '/#/we?index=1&id=4', title: '联系我们'},
                                        ]


                                    } ,

                                 ], url: '' },
                                {title: '人才招聘', children: [ {title: '人才招聘', url: '/#/we?index=2'}, ], url: ''}
                            ],

                    },
            ]
        }
    },
    mounted() {
        window.addEventListener('resize', this.nresize);
        this.bodyW = document.body.clientWidth;
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.nresize);
    },
    methods:{
        nresize(){
             this.bodyW = document.body.clientWidth
        },
        openNav(item,isLeft){

            // if(!item.children || !item.children.length) return item.url && (location.href = item.url);

            isLeft ? ( this.navConf.leftCur = item) : this.$set(item,'open',!item.open);

        },
        goTo(){

          // console.log(111)
        },
        getFreeTrial() {
            this.textList = []
            uploadAction(`https://iboran.com/api.php/list/${113}/num/4/page/1/order/istop`).then(res => {
                this.textList = res.data.data
            }).catch(err => {
                alert(err.message)
            })
        },
        getFreeTrial2() {
            this.textList2 = []
            uploadAction(`https://iboran.com/api.php/list/${114}/num/4/page/1/order/istop`).then(res => {
                this.textList2 = res.data.data
            }).catch(err => {
                alert(err.message)
            })
        },
        getImg() {
            // api.php/cms/site
            this.headerImg = ''
            uploadAction(`https://iboran.com/api.php/cms/site`).then(res => {
                this.headerImg = res.data.data.logo
            }).catch(err => {
                alert(err.message)
            })
        },
        getMenuNav() {
            this.menuList = []
            uploadAction(`https://iboran.com/api.php/cms/nav`).then(res => {
                this.menuList = res.data.data[3].son
            }).catch(err => {
                alert(err.message)
            })
        },
        getCode(code) {
            if (this.$route.meta.id) {
                uploadAction(`https://iboran.com/api.php/cms/sort/scode/${this.$route.meta.id}`).then(res => {
                    document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
                    document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.description)
                    document.title = res.data.data.title;
                    this.$route.meta.title = res.data.data.title;
                    this.$route.meta.content.keywords = res.data.data.keywords;
                    this.$route.meta.content.description = res.data.data.description;
                }).catch(err => {
                    alert(err.message)
                })
            }
        }
    },
    created() {
        this.getFreeTrial()
        this.getFreeTrial2()
        this.getMenuNav()
        this.getImg()
        this.getCode(this.$route.meta.id)


        console.log(this.$route, '$route.meta------ccccccmm-------------mmmmmmccc-----------$route.meta')
    },
    beforeunload() {

    },
   }
</script>
<style lang="scss" scoped>
    .n-nav{
       &, *{
        	margin: 0;
        	padding: 0;
        	box-sizing: border-box;
        	color: inherit;
        	font-size: inherit;
        	line-height: inherit;
        	font-weight: inherit;
        	font-style: normal;
        	border: 0;
         }


         html,body,page{
        	width: 100%;
        	margin: auto;
        	font-size: 12px;
        	position: relative;
         }
         header,main,footer,div,section,nav,aside,article,section,h1,h2,h3,h4,h5,h6{
        	display: block;
         }
         ul, ol, li ,dl, dd, dt {
           list-style: none;
           list-style-type: none
         }


         input,textarea{
        	-webkit-appearance: none;
        	appearance: none;
        	outline: none;
         }

         a,i,a:hover {
        	text-decoration: none;
        	cursor: pointer;
         }
         table{
        	border-collapse: collapse;
         }

         img ,label{
        	cursor: pointer;
         }



    }
    @mixin n-row1{
     	display: flex;
     	align-items: center;
     }
     @mixin n-row2{
     	display: flex;
     	justify-content: center;
     	align-items: center;
     }
     @mixin n-row3{
     	display: flex;
     	justify-content: flex-end;
     	align-items: center;
     }
     @mixin n-row4{
     	display: flex;
     	justify-content: space-around;
     	align-items: center;
     }
     @mixin n-row5{
     	display: flex;
     	justify-content: space-between;
     	align-items: center;
     }

     @mixin n-col1{
     	display: flex;
     	flex-direction: column;
     }
     @mixin n-col2{
     	display: flex;
     	justify-content: center;
     	flex-direction: column;
     }
     @mixin n-col3{
     	display: flex;
     	justify-content: flex-end;
     	flex-direction: column;
     }
     @mixin n-col4{
     	display: flex;
     	justify-content: space-around;
     	flex-direction: column;
     }
     @mixin n-col5{
     	display: flex;
     	justify-content: space-between;
     	flex-direction: column;
     }

     @mixin hideScroll {
     	&::-webkit-scrollbar {
     		width: 0;
    		display: none;
     		height: 0;
     	}

     	&::-webkit-scrollbar-thumb {
     		width: 0;
     		display: none;
     		height: 0;
     	}

     	&::-webkit-scrollbar-button {
     		display: none;
     	}
     }



    $c:#cc0817;
    .n-nav:not([__null__]){
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        .n-nav-head{
            background: #fff;
            height: 50px;
            @include n-row5;
            padding: 0 4vw;
            >img{
                height: 26px;
                &:nth-child(2){
                    height: 15px;
                    margin-right: 6%;
                }
            }
        }

        .n-nav-pop{
            position: absolute;
            left: 0;
            width: 100vw;
            top: 100%;
            @include n-row1;
            left: -200vw;
            align-items: stretch;
            height: calc(100vh - 50px);
            >aside{
                @include n-col1;
                align-items: center;
                background: #f6f6f6 url(../assets/101.png) no-repeat left bottom / 100% auto;
                padding: 5px;
                width: 35vw;
                position: relative;
                z-index: 3;
                transform: translate(-100%);
                transition: all 0.3s;
                >ul{
                    width: 100%;
                    padding: 15px 0;
                    >li{
                        @include n-row1;
                        font-size: 12px;
                        cursor: pointer;
                        color: #222;
                        font-weight: bold;
                        padding-left: 20px;
                        margin-bottom: 40px;
                    }
                    .n-nav-cur{
                        padding-left: 18px;
                        color: $c;
                        border-left: 2px solid $c;
                    }
                }
                >img{
                    cursor: pointer;
                    margin-top: auto;
                    height: 30px;
                }
            }

            .n-nav-pop-right{
                background: #fff;
                padding: 0 10px;
                transform: translate(-200%);
                transition: all 0.3s;
                flex: 1;
                width: 0;
                overflow: hidden;
                overflow-y: auto;
                >h3{
                    background: #fff;
                    height: 50px;
                    @include n-row1;
                    position: sticky;
                    top: 0;
                    z-index: 2;
                    font-size: 15px;
                    color: #555;
                    border-bottom: 1px solid #eee;
                    >i{
                        margin-left: 10px;
                        font-family: '宋体';
                        font-weight: bold;
                    }
                }
                &.n-nav-pop-rightShow{
                    transform: translate(0);
                }
                .n-nav-list{
                    max-height: 0;
                    overflow: hidden;
                    font-size: 13px;
                    color: #555;
                    max-height: 0;
                    transition: all 0.3s;
                    >li{
                        >div{
                            height: 40px;
                            cursor: pointer;
                            @include n-row1;
                            >img{
                                margin-left: auto;
                                height: 5px;
                                transition: all 0.3s;
                            }
                        }
                        >.n-nav-list{
                            padding-left: 20px;
                        }
                    }
                    &.n-nav-listOpen{
                        max-height: 1000px;
                    }
                }
            }
            &.n-nav-popShow{
                left: 0;
                >aside{

                    transform: translate(0);
                }
            }
        }

    }
</style>
<style lang="scss" scoped>
    .Aheader{
        position: relative;
        width: 100%;
        >div:nth-of-type(1){
            width: 100%;
            height: 5rem;
            position: fixed;
            top: 0;
            left: 0;
            box-shadow: 0rem 0rem 0.6875rem 0rem rgba(0,0,0,0.1);
            font-size: 1rem;
            background: #ffffff;
            z-index: 999;
            >div{
                width: 75rem !important;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .logo{
                    width: 16.625rem;
                    height: 3.125rem;
                    margin-left: 1.875rem;
                    cursor: pointer;
                }
                .h_r{
                    display: flex;
                    align-items: center;
                    margin-right: 1.875rem;
                    min-width: 53.75rem;
                    .h_r_i{
                        >div:nth-of-type(1){
                            height: 5rem;
                            line-height: 5rem;
                            margin-left: 3.125rem;
                            color: #333333;
                            cursor: pointer;
                        }
                        >.h_r_i_2
                        >.h_r_i_2_2, .bbbb:nth-of-type(3){
                            flex-grow: 1.5 !important;
                        }
                        >.h_r_i_2,
                        >.h_r_i_22,
                        >.h_r_i_23 {
                            width: 62.5rem;
                            min-height: 26.875rem;
                            position: absolute;
                            top: 5rem;
                            left: calc(140% - 30rem);
                            background: #ffffff;
                            border-radius: 0 0 0.3125rem 0.3125rem;
                            box-shadow: 0rem 0rem 0.5rem 0rem rgba(0, 0, 0, 0.13);
                            transition: transform 0.3s linear;
                            display: none;
                            >div{
                                display: flex;
                                >.h_r_i_2_2,
                                >.h_r_i_2_22{
                                    padding: 1.875rem;
                                    flex: 1;
                                    >div:nth-of-type(1){
                                        font-size: 0.875rem;
                                        margin-bottom: 0.3125rem;
                                        border-bottom: 0.0625rem solid #333;
                                        font-weight: bold;
                                        cursor: pointer !important;
                                    }
                                    >.h_r_i_2_3{
                                        line-height: 2;
                                        color: #666;
                                        cursor: pointer;
                                        font-size: 0.875rem;
                                        .hot{
                                            text-align: center;
                                            display: inline-block;
                                            width: 2.5rem;
                                            height: 1.25rem;
                                            line-height: 1.25rem;
                                            font-weight: bold;
                                            font-size: 0.875rem;
                                            border: 0.0625rem solid #e31924;
                                            color: #e31924;
                                            border-radius: 0.125rem;
                                            scale: .6;
                                        }
                                    }
                                }
                            }

                        }
                        .h_r_i_22{
                            width: 10rem;
                            min-height: 8.75rem !important;
                            text-align: center;
                            left: 0;
                            >div{
                                display: block;
                                margin-top: 1.25rem;
                                >.h_r_i_2_22{
                                    padding: 0.625rem 2.5rem;
                                    cursor: pointer !important;
                                    >div:nth-of-type(1){
                                        border: none;
                                        //background: pink;
                                        display: block;
                                        cursor: pointer !important;

                                    }
                                >div:nth-of-type(1):hover{
                                    .sub{
                                        display: block;
                                    }
                                }
                                }
                            }

                        }
                        .h_r_i_23{
                            width: 20rem;
                            min-height: 8.75rem !important;
                            text-align: center;
                            left: 0;
                            >div{
                                display: block;
                                margin-top: 1.25rem;
                                >.h_r_i_2_22{
                                    padding: 0.625rem 2.5rem;
                                    >div:nth-of-type(1){
                                        border: none;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                        .ys{
                            width: 75rem;
                            // min-height: 31.25rem;
                            position: absolute;
                            top: 5rem;
                            left: calc(50% - 50.625rem)!important;
                            background: #ffffff;
                            border-radius: 0 0 0.3125rem 0.3125rem;
                            box-shadow: 0rem 0rem 0.5rem 0rem rgba(0, 0, 0, 0.13);
                            transition: transform 0.3s linear;
                            display: none;
                            >div{
                                display: flex;
                                >.content,
                                >.content2{
                                    flex: 1;
                                    padding: 1.875rem;
                                    .news{
                                        font-size: 1.125rem;
                                        font-weight: bold;
                                        margin-bottom: 1.25rem;
                                        cursor: pointer;
                                    }
                                    .ccc{
                                        >div{
                                            display: flex;
                                            margin-bottom: 0.875rem;
                                            cursor: pointer;
                                            >img{
                                                width: 3.75rem;
                                                height:3.75rem;
                                                border-radius: 0.625rem;
                                                margin-right: 0.625rem;
                                            }
                                            >div{
                                                display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 2;
                                                overflow: hidden;
                                                text-overflow: ellipsis;   // 不写也行
                                            }
                                        }
                                    }
                                }
                                .line{
                                    margin: 1.875rem;
                                    width: 0.0625rem;
                                    background: #999999;
                                }
                                >.content2{

                                }
                            }
                        }
                        .h_r_i_11{
                            width: 68.75rem;
                            min-height: 31.25rem;
                            position: absolute;
                            top: 5rem;
                            left: calc(140% - 37.5rem);
                            background: #ffffff;
                            border-radius: 0 0 0.3125rem 0.3125rem;
                            box-shadow: 0rem 0rem 0.5rem 0rem rgba(0, 0, 0, 0.13);
                            transition: transform 0.3s linear;
                            display: none;
                            >div{
                                display: flex;
                                .i_11_left{
                                    width: 10rem;
                                    min-height: 31.25rem;
                                    height: 100%;
                                    background: #fbf5f5;
                                    padding: 0 1.875rem;
                                    >div{
                                        height: 3.125rem;
                                        line-height: 3.125rem;
                                        cursor: pointer;
                                    }
                                    >div:hover{
                                        color: #c13939;
                                    }
                                }
                                .i_11_right{
                                    display: flex;
                                    justify-content: space-between;
                                    flex-wrap: wrap;
                                    align-content:flex-start;
                                    flex: 1;
                                    >div{
                                        width: 25%;
                                        padding: 0 1.25rem;
                                        margin-top: 1.25rem;
                                        >div{
                                            cursor: pointer;
                                            >span:nth-of-type(1){
                                                font-size:0.875rem;
                                                margin-bottom: 0.3125rem;
                                                font-weight: bold;
                                                cursor: pointer;
                                            }
                                            >span:nth-of-type(2) {
                                                line-height: 2;
                                                color: #666;
                                                cursor: pointer;
                                                font-size: 0.875rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .h_r_i:hover{
                        >.h_r_i_2,
                        >.h_r_i_22,
                        >.h_r_i_23,
                        >.h_r_i_11,
                        >.ys{
                            display: block;
                        }
                    }
                    .but{
                        width: 8.75rem;
                        height: 2.5rem;
                        line-height: 2.5rem;
                        text-align: center;
                        background: #e6322e;
                        color: #ffffff;
                        cursor: pointer;
                        margin-left: 3.125rem;
                    }
                }
            }
        }
    }
    .aaa{
        line-height: 2;
        color: #666;
        cursor: pointer;
        font-size: 0.875rem;
        .hot{
            text-align: center;
            display: inline-block;
            width: 2.5rem;
            height: 1.25rem;
            line-height: 1.25rem;
            font-weight: bold;
            font-size: 0.875rem;
            border: 0.0625rem solid #e31924;
            color: #e31924;
            border-radius: 0.125rem;
            scale: .6;
        }
    }
.menuSty div{
    width: 5rem;
}
    li dd a {
        padding: 0;
        font-size: 0.875rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }

    .h_r_i_22>div>.h_r_i_2_22:nth-of-type(1):hover{
        .sub{
            display: block;
        }
    }
    .h_r_i_22>div>.h_r_i_2_22>div>ul>li>a{
        color: #000000;
        text-decoration: none;

    }
    .sub {
        display: none;
        position: absolute;
        right: -10rem;
        top: 0;
        background: #fff;
        width: 10rem;
    }
    .ul, .ul li {
        list-style: none;
    }
    .sub li {
        display: block;
        float: none;
        line-height: 2.5rem;
        padding: 0 1.25rem;
    }
    li {
        position: relative;
    }
    li dd .sub li a {
        display: block;
        line-height: 2.5rem;
        margin: 0;
        border-bottom: solid 0.0625rem #f2f2f2;
        color: #000000;
        text-decoration: none;
    }
    li dd a {
        padding: 0;
        font-size: 0.875rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: block;

    }
</style>



// WEBPACK FOOTER //
// src/components/header.vue